<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <h2>
      搬入予約詳細
    </h2>
    <request-carry-in-detail :order-id="orderId" />
  </v-container>
</template>
<script>
import RequestCarryInDetail from "../../shared/_RequestCarryInDetail.vue";

export default {
  name: 'OrderRequestCarryIn',
  components: {
    RequestCarryInDetail
  },
  mixins: [],
  props: {},
  data() {
    return {
      breadcrumbs: [],
      orderId: this.$route.params.id,
    }
  },
  computed: {},
  watch: {},
  created() {
    this.breadcrumbs = []
    if (this.$route.query.d !== undefined) {
      this.breadcrumbs.push({ text: 'ダッシュボード', disabled: false, to: '/driver/home', exact: true })
    } else {
      this.breadcrumbs.push({ text: '発注（積替・搬入）', disabled: false, to: '/driver/orders/requests', exact: true })
    }
    this.breadcrumbs.push({ text: '搬入予約詳細', disabled: true, to: '' })

  },
  methods: {}
}
</script>
